import api from 'api/instance';
import { FetchQueryType, FetchResponse } from 'types/common';
import { Manufacturer } from 'types/manufacturer';

const URL = `${process.env.REACT_APP_API_URL}`;

export const fetchManufacturers = async (params: FetchQueryType = {}) => {
  const { data } = await api.get<FetchResponse<Manufacturer>>(
    `${URL}/manufacturer/list`,
    {
      params: {
        limit: 1000,
        ...params,
      },
    },
  );

  return data?.items ?? [];
};

/** Every field a super admin sets on a manufacturer (ClickUp 86bceudwp). */
export type ManufacturerPayload = {
  name: string;
  email: string[];
  address?: {
    addressLine1: string;
    addressLine2?: string;
    city: string;
    state: string;
    zip: string;
    country?: string;
  };
  quickbooksVendorId?: string;
};

export const createManufacturer = async (payload: ManufacturerPayload) => {
  const { data } = await api.post(`${URL}/manufacturer`, payload);

  return data;
};

export const updateManufacturer = async ({
  _id,
  ...payload
}: ManufacturerPayload & { _id: string }) => {
  const { data } = await api.patch(`${URL}/manufacturer/${_id}`, payload);

  return data;
};
